import { Error500 } from 'components/common/errors';
import { useLogout } from 'core/uses-cases/authentication';
import { router } from 'navigation';
import { ErrorLayout } from './layout';

type ErrorFallbackOptions = {
	componentStack: React.ErrorInfo['componentStack'] | null;
	error: Error | null;
	resetError: () => void;
	eventId: string | null;
};

const Error500Page = ({ resetError }: ErrorFallbackOptions) => {
	const { doLogout } = useLogout();

	const handleOnReset = () => {
		doLogout();
		resetError();
		// Use full page navigation so we leave the community URL before the app
		// re-mounts. Otherwise AuthenticatedGuard redirects to request-to-join
		// when it sees an unauthenticated user at a community URL.
		window.location.replace(router.getPathFor('account.login'));
	};

	return (
		<ErrorLayout>
			<Error500 onReset={handleOnReset} />
		</ErrorLayout>
	);
};

export const createErrorFallback = (options: ErrorFallbackOptions) => {
	return <Error500Page {...options} />;
};
